module.exports = __webpack_public_path__ + "static/media/paymentsuccess.55f8d574.png";